import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import axios, { isAxiosError, AxiosError } from 'axios';

import SubmissionStatus from './submission-status';
import FormErrors from '../../../global/components/public/form-errors';
import Button from '../../../global/components/public/button';

const forgotPasswordUrl = (mhqp) => mhqp ? '/model/api/loginProcessor.cfc?method=forgotPwdMhqpV2' : '/model/api/loginProcessor.cfc?method=forgotPwdV2';

const forgotFormSchema = z.object({
    userName: z.string().email('Invalid email address')
});

type Inputs = {
    userName?: string
};

const ForgotPasswordForm: React.FC<{ mhqp: boolean }> = ({ mhqp = false }) => {

    const [ submision, setSubmission ] = useState(false);
    const [ userName, setUserName ] = useState<string | undefined>();
    const [ error, setError ] = useState<{errcode: number}>(null);
    const { register, errors, handleSubmit } = useForm<Inputs>({ resolver: zodResolver(forgotFormSchema) });

    const onSubmit = async (data: Inputs, event?: React.BaseSyntheticEvent) => {

        const formEvent = event as React.FormEvent<HTMLFormElement>;
        formEvent.preventDefault();

        try {
            setUserName(data.userName);            
            await axios.post(forgotPasswordUrl(mhqp), {...data, reCaptcha: 'filled'});            
            setSubmission(true);            
        } catch(error) {
            if (isAxiosError(error)) {

                if ( (error as AxiosError).response.status === 406 && (error as AxiosError).response.statusText === 'Unable to process' ) {
                    setError( { errcode: 10 } );
                    return;
                }

                if ( (error as AxiosError).response.status === 406 && (error as AxiosError).response.statusText === 'SAML User' ) {
                    setError( { errcode: 20 } );
                    return;
                }                

                if ( (error as AxiosError).response.status === 429 ) {
                    setError( { errcode: 30 } );
                    return;
                }

                setError( { errcode: 40 } );            
            }
        }
    };

    if (error) {
        return <Redirect to={`/error/${error.errcode}`} />;
    }    
    
    return <>
        {
            submision ? 
                <SubmissionStatus userName={userName} mhqp={mhqp} /> :
                <>
                    <form onSubmit={handleSubmit(onSubmit)} className='forgot-password-form'>
                        <h2 className='mb-4'>Forgot your password?</h2>
                        <div className='row mb-3'>
                            <div className='col-12'>
                                <p>Please enter your User ID (email).</p>
                            </div>
                        </div>
                        <div className='row mb-4'>
                            <div className='col-12 mb-5'>
                                <input
                                    ref={register()}
                                    type='text' 
                                    className={`form-control ${errors?.userName ? 'error light' : '' }`} 
                                    id='userName' 
                                    name='userName' 
                                    title='User ID (email)' 
                                    placeholder='User ID (email)' />
                                <FormErrors className='text-xs mt-1 pt-0 mb-2 text-light-danger' error={errors?.userName} />
                            </div>
                            <div className='col-12 mb-5'>
                                <Button type='submit'>Submit</Button>
                            </div>
                        </div>
                    </form>                
                </>
            }
        </>;    
}

export default ForgotPasswordForm;